function count() {
    if($(this).isOnScreen() && !$(this).hasClass('-counted')) {
        $(this).prop('Counter', 0).animate({
            Counter: $(this).data('number')
        }, {
            duration: 3000,
            easing: 'swing',
            step: function (now) {
                $(this).text(Math.ceil(now).toLocaleString('en'));
            }
        });
        $(this).addClass('-counted');
    }
}

$('.counter__items [data-number]').each(count);

$(document).on('scroll', function(){
    $('.counter__items [data-number]').each(count);
});